import { useState } from "react";

import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

import type { ISimpleWarningModalHook } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/components/useSimpleWarningModal";
import { useSimpleWarningModal } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/components/useSimpleWarningModal";

interface IDeleteTopicModalHook extends Pick<ISimpleWarningModalHook, "modal"> {
    openModal: (topic: string) => void;
}

export const useDeleteTopicModal = (onDelete: (topic: string) => void): IDeleteTopicModalHook => {
    const [topicToDelete, setTopicToDelete] = useState<string>("");

    const resetState = (): void => {
        setTopicToDelete("");
    };

    const onCancel = (): void => {
        allTrackers.dispatchTrackEvent("Edit Campaign", "click", "delete topic/cancel");
    };

    const onSubmit = (): void => {
        allTrackers.dispatchTrackEvent("Edit Campaign", "click", "delete topic/submit");
        onDelete(topicToDelete);
    };

    const { openModal: openGenericModal, modal } = useSimpleWarningModal({
        title: translate("llm.prompts.edit.topics-table.delete.title"),
        tooltip: translate("llm.prompts.edit.topics-table.delete.tooltip"),
        text: translate("llm.prompts.edit.topics-table.delete.text", {
            topic: topicToDelete,
        }),
        ctaText: translate("common.delete"),
        onCancel,
        resetState,
        onSubmit,
    });

    const openModal = (topic: string): void => {
        setTopicToDelete(topic);
        openGenericModal();
    };

    return {
        openModal,
        modal,
    };
};
